import styled from 'styled-components';
import theme from '../../theme';
import { domainIconMapRaw } from '../Onboarding/domainIconMap'; // Keep if needed for domainOptions

// Export constants if they are needed by the styles directly (unlikely for these)
// export const domainOptions = Object.keys(domainIconMapRaw);
// export const formationTypeOptions = [...];

// Export styles
export const CreateCardContainer = styled.div`
  padding: 2rem 1rem 2rem 1rem; /* Adjusted padding for smaller screens */
  width: 100%;
  box-sizing: border-box;
  font-family: 'Fustat', sans-serif;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  align-items: stretch;
  min-height: 100vh;
  overflow-y: auto;

  @media (min-width: 768px) { /* Apply original padding on larger screens */
    padding: 4rem 1rem 2rem calc(60px + 6rem);
  }
`;

export const CreateCard = styled.div`
  width: 100%;
  max-width: 1100px; /* Added max-width */
  border-radius: 20px;
  border: 1px solid #E6E6E6;
  background: #FEFFFE;
  padding: 1rem; /* Adjusted padding */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding: 1.5rem; /* Original padding */
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column; /* Stack items vertically by default */
  align-items: stretch; /* Stretch items to full width */
  gap: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;

  @media (min-width: 768px) { /* Row layout on larger screens */
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const TitleWrapper = styled.div`
  flex: 2;
  min-width: 0; /* Removed min-width for better stacking */
`;

export const EstablishmentWrapper = styled.div`
  flex: 1;
  min-width: 0; /* Removed min-width */
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: #FEFFFE;
  color: #29435B;
  box-sizing: border-box;
  margin-top: 0.25rem;
  font-family: 'Fustat', sans-serif;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
      border-color: #38B6FF;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: #FEFFFE;
  color: #29435B;
  box-sizing: border-box;
  margin-top: 0.25rem;
  min-height: 80px;
  font-family: 'Fustat', sans-serif;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
      border-color: #38B6FF;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const FormationTitleInput = styled(TextArea)`
  font-weight: 600;
  resize: none;
  overflow-y: hidden;
  height: auto;
  min-height: 1.4em;
  line-height: 1.4;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  display: block;
`;

export const InfoSection = styled.div`
  margin-bottom: 1.5rem; /* Increased margin */
  padding-bottom: 1.5rem; /* Increased padding */
  /* border-bottom: 1px solid #eee; --- REMOVED SEPARATOR --- */

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* Add gap between elements within an item */
`;

export const InfoLabel = styled.label`
  font-size: 0.9rem;
  font-weight: 600;
  color: #29435B;
  margin-bottom: 0.1rem; /* Reduced margin */
  font-family: 'Fustat', sans-serif;
`;

export const SubInfoLabel = styled(InfoLabel)`
    font-size: 0.85rem;
    font-weight: 500;
    color: #555;
    margin-left: 0.5rem; /* Indent sub-label */
`;

export const SectionTitle = styled.h3`
    font-size: 1.1rem;
    font-weight: 600;
    color: ${theme.colors.bleu_fonce};
    margin-top: 0;
    margin-bottom: 0.25rem; /* Reduced bottom margin */
    padding-bottom: 0.5rem;
`;

export const SectionSubtitle = styled.p`
    font-size: 0.85rem;
    font-weight: 500;
    color: #667;
    margin-top: 0; /* Remove top margin */
    margin-bottom: 1rem; /* Add bottom margin before the grid */
`;

export const StyledInput = styled(Input)`
  font-size: 0.9rem;
  margin-top: 0; /* Remove default top margin */
`;

export const SubInput = styled(StyledInput)`
    margin-left: 0.5rem; /* Indent sub-input */
    width: calc(100% - 0.5rem); /* Adjust width for indentation */
`;

export const StyledTextArea = styled(TextArea)`
  font-size: 0.9rem;
  margin-top: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column; /* Stack buttons on small screens */
  align-items: stretch; /* Make buttons full width */
  gap: 0.75rem; /* Reduced gap for stacking */
  margin-top: 1.5rem;
  padding-top: 1rem;

  @media (min-width: 600px) { /* Row layout and original width on larger screens */
    flex-direction: row;
    justify-content: flex-end;
    gap: 1rem;

    & > button {
      width: 235px; /* Restore original width */
    }
  }
`;

export const CancelButton = styled.button`
  width: 100%; /* Full width on small screens */
  height: 45px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #E6E6E6;
  background: #FFF;
  color: #38B6FF;
  font-family: 'Fustat', sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover {
      background-color: #f5f5f5;
      border-color: #ccc;
  }

  &:disabled {
      background-color: #eee;
      color: #aaa;
      cursor: not-allowed;
      border-color: #ddd;
  }
`;

export const ConfirmButton = styled.button`
  width: 100%; /* Full width on small screens */
  height: 45px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #38B6FF;
  border: none;
  color: #FFF;
  font-family: 'Fustat', sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
      background-color: ${theme.colors.bleu_fonce};
  }

  &:disabled {
      background-color: #a0d8ff;
      cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: #e74c3c;
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #fde8e8;
  border-radius: 4px;
  text-align: center;
`;

export const SuccessMessage = styled.div`
  color: #2ecc71;
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #e8fde8;
  border-radius: 4px;
  text-align: center;
`;

export const StyledSelect = styled.select`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: #FEFFFE;
  color: #29435B;
  box-sizing: border-box;
  margin-top: 0;
  font-family: 'Fustat', sans-serif;
  outline: none;
  appearance: none;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%2329435B%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 0.65em auto;
  cursor: pointer;

  &:focus {
      border-color: #38B6FF;
  }
`;

export const ExtendedTextArea = styled(StyledTextArea)`
  min-height: 120px;
  height: auto;
  resize: none;
  line-height: 1.4;
  padding-bottom: 1.2rem;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const CheckboxLabel = styled.label`
  margin-left: 0.5rem;
  font-size: 0.9rem;
  color: #29435B;
  cursor: pointer;
`;

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
`;

export const SelectedDomainsDisplay = styled.div`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: #FEFFFE;
  color: #29435B;
  box-sizing: border-box;
  min-height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0;

  &::after {
    content: '';
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #29435B;
  }
`;

export const DropdownContent = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  background: #FFF;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  padding: 0.75rem;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  max-height: 200px;
  overflow-y: auto;
`;

export const InputWithPercentage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem; 

  input {
    max-width: 80px; 
    flex-grow: 0; 
    flex-shrink: 0; 
  }

  span {
    flex-shrink: 0; 
  }
`;

export const PercentageSumWarning = styled.div`
    color: #e67e22; /* Orange warning color */
    font-size: 0.85rem;
    font-weight: 500;
    margin-top: 0.75rem;
    padding: 0.4rem 0.8rem;
    background-color: #fdf3e6;
    border: 1px solid #f8cba9;
    border-radius: 5px;
    text-align: center;
`;

// --- react-select Styles --- 
// Note: This is a JS object, not a styled-component. 
// It's often kept in the component file or a separate utils/config file.
// For consistency, we'll move it, but be mindful it's just an object.
export const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? `1px solid ${theme.colors.bleu_clair}` : '1px solid #E6E6E6',
    borderRadius: '10px',
    minHeight: '40px', // Match input height
    boxShadow: state.isFocused ? `0 0 0 1px ${theme.colors.bleu_clair}` : 'none',
    '&:hover': {
      borderColor: state.isFocused ? theme.colors.bleu_clair : '#ccc',
    },
    marginTop: '0.25rem',
    fontSize: '0.9rem',
    fontFamily: 'Fustat, sans-serif',
  }),
  input: (provided) => ({
      ...provided,
      color: '#667',
      fontFamily: 'Fustat, sans-serif',
      fontSize: '0.85rem',
      fontWeight: 500,
  }),
  placeholder: (provided) => ({
      ...provided,
      color: '#aaa',
      fontSize: '0.85rem',
      fontFamily: 'Fustat, sans-serif',
      fontWeight: 500,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#667',
    fontSize: '0.85rem',
    fontFamily: 'Fustat, sans-serif',
    fontWeight: 500,
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '10px',
    marginTop: '4px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? theme.colors.bleu_clair : state.isFocused ? '#f0f8ff' : 'white',
    color: '#667',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontFamily: 'Fustat, sans-serif',
    fontWeight: 500,
    '&:active': {
        backgroundColor: '#e0f0ff'
    }
  }),
}; 